import React, { Component } from 'react';
import { connect } from 'react-redux';
import Actions from '~/Actions';
import {
  Button,
  Select,
  MenuItem,
  TableRow,
  TableCell,
  TableHead,
  TableContainer,
  TableBody,
  Table,
} from '@material-ui/core';
import { ArrowBackIos, ArrowForwardIos, FirstPage, LastPage } from '@mui/icons-material';
import { EAA_Btn } from '~/components/EditAndAddItem';
import { leftColor } from '~/components/EditAndAddItem/common';
import { T_TitleCell, T_TableRow } from '~/components/TableItem';
import PageTitle from '~/components/PageTitle';
import CheckExport from '~/components/Dialog/CheckExport';

class RecordView extends Component {
  state={
    per_page: 10,
    page: 1,
    sort: {},
    dialog_Export: false,
  }

  componentDidMount () {
    const { id, getCheckIdDetail, setPageText } = this.props;
    setPageText('清查作業檢視紀錄');
    getCheckIdDetail(id);
    this.refresh();
  }

  componentWillUnmount () {
    this.props.clearKey('CheckIdDetail');
    this.props.clearKey('PageText');
  }

  refresh=() => {
    const { id, getCheckIdPageList } = this.props;
    const { page, per_page } = this.state;
    const body = {
      sort: 'desc',
      sort_field: 'user_check_log.account',
      user_check_id: id,
    };
    getCheckIdPageList({
      page,
      per_page,
      body,
    });
  }

  search=() => this.setState({ page: 1 }, () => this.refresh());

  renderTableTitle=() => {
    const ary = [
      { name: '序號' },
      { name: '使用者帳號' },
      { name: '姓名' },
      { name: '電子信箱' },
      { name: '聯絡電話' },
      { name: '清查狀態' },
      { name: '確認日期 / 時間' },
    ];
    return (
      <TableHead>
        <TableRow style={{ height: 48 }}>
          {ary.map((o, i) => <T_TitleCell key={i} text={o.name} />)}
        </TableRow>
      </TableHead>
    );
  }

  renderTableBody=() => {
    const { checkIdPageList = {} } = this.props;
    const { user_check_log_list = [] } = checkIdPageList;
    const statusInfo = { 0: { text: '未確認', color: '#FF0000' }, 1: { text: '已確認', color: '#1A63AC' }, 2: { text: '已結束', color: '#979797' } };
    const cellStyle = { fontSize: 14 };
    return (
      <TableBody>
        {user_check_log_list.map((o, i) => (
          <T_TableRow key={i} backgroundColor= {i % 2 === 0 ? '#E0FDFF' : 'white'}>
            <TableCell align='center' style={cellStyle}>{i + 1}</TableCell>
            <TableCell align='center' style={cellStyle}>{o.account}</TableCell>
            <TableCell align='center' style={cellStyle}>{o.name}</TableCell>
            <TableCell align='center' style={cellStyle}>{o.email}</TableCell>
            <TableCell align='center' style={cellStyle}>{o.tel_number}</TableCell>
            <TableCell align='center' style={{ ...cellStyle, color: statusInfo[o.status].color }}>{statusInfo[o.status].text}</TableCell>
            <TableCell align='center' style={cellStyle}>{o.active_time || '-'}</TableCell>
          </T_TableRow>
        ))}
      </TableBody>
    );
  }

  renderTableBar=() => {
    const { checkIdPageList = {} } = this.props;
    const { has_next = false, has_prev = false, page = 0, pages = 0, total = 0 } = checkIdPageList;
    const { per_page, page: statePage } = this.state;
    const returnPages = () => {
      const array = [];
      for (let i = 1; i <= pages; i++) {
        array.push(i);
      }
      return array;
    };
    const returnPers = () => [10, 20, 30, 40];
    const canFirst = page > 1;
    const canLast = page < pages;
    return (
      <div style={{ height: 48, display: 'flex', alignItems: 'center', width: '98%', backgroundColor: 'white', borderBottomRightRadius: 8, borderBottomLeftRadius: 8, paddingTop: 6, paddingBottom: 6 }}>
        <div style={{ flex: 1 }} />
        <FirstPage style={{ height: 24, width: 24, color: canFirst ? 'black' : 'gray', cursor: canFirst ? 'pointer' : 'default' }} onClick={() => { if (canFirst) this.setState({ page: 1 }, () => this.refresh()); }} />
        <ArrowBackIos style={{ marginLeft: 3, marginRight: 5, height: 16, width: 16, color: has_prev ? 'black' : 'gray', cursor: has_prev ? 'pointer' : 'default' }} onClick={() => { if (has_prev) this.setState({ page: this.state.page - 1 }, () => this.refresh()); }} />
        <div style={{ fontSize: 14 }}>第</div>
        <Select
          style={{ backgroundColor: 'white', height: 36, fontSize: 16, letterSpacing: '0.15px', marginRight: 8, marginLeft: 8 }}
          variant="outlined"
          value={statePage}
          onChange={e => this.setState({ page: e.target.value }, () => { this.refresh(); })}
        >
          {returnPages().map((o, i) => <MenuItem key={i} value={o}>{o}</MenuItem>)}
        </Select>
        <div style={{ fontSize: 14, marginRight: 8 }}>{`/${pages} 頁，每頁`}</div>
        <Select
          style={{ backgroundColor: 'white', height: 36, fontSize: 16, letterSpacing: '0.15px' }}
          variant="outlined"
          value={per_page}
          onChange={e => this.setState({ per_page: e.target.value }, () => { this.search(); })}
        >
          {returnPers().map((o, i) => <MenuItem key={i} value={o}>{o}</MenuItem>)}
        </Select>
        <div style={{ fontSize: 14, marginLeft: 8 }}>{`筆，共${total}筆`}</div>
        <ArrowForwardIos style={{ marginLeft: 5, height: 16, width: 16, color: has_next ? 'black' : 'gray', cursor: has_next ? 'pointer' : 'default' }} onClick={() => { if (has_next) this.setState({ page: this.state.page + 1 }, () => this.refresh()); }} />
        <LastPage style={{ marginRight: 19, height: 24, width: 24, color: canLast ? 'black' : 'gray', cursor: canLast ? 'pointer' : 'default' }} onClick={() => { if (canLast) this.setState({ page: pages }, () => this.refresh()); }} />
        <div style={{ flex: 1 }} />
      </div>
    );
  }

  renderTable=() => {
    const { checkIdPageList = {} } = this.props;
    const { user_check_log_list = [] } = checkIdPageList;
    const haveData = user_check_log_list.length > 0;
    return (
      <TableContainer style={{ marginTop: 18, maxWidth: '98%' }}>
        <Table style={{ backgroundColor: 'white', borderTopLeftRadius: 8, borderTopRightRadius: 8 }}>
          {this.renderTableTitle()}
          {haveData && this.renderTableBody()}
        </Table>
      </TableContainer>
    );
  }

  render () {
    const { _onClose, checkIdDetail = {}, id, exportCheckIdExcel, checkIdPageList = {} } = this.props;
    const { total = 0, user_check_log_list = [] } = checkIdPageList;
    const { dialog_Export } = this.state;
    const haveData = user_check_log_list.length > 0;
    return (
      <div style={{
        position: 'absolute',
        left: 13,
        right: 0,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        overflow: 'auto',
      }}
      >
        <PageTitle text={'清查作業檢視紀錄'} />
        <div style={{ height: 5 }} />
        <div style={{ display: 'flex', width: '100%', alignItems: 'center', marginTop: 5, marginBottom: 23 }}>
          <div style={{ flex: 1 }} />
          <div style={{ fontSize: 18 }}>{`清查名稱：${checkIdDetail.user_check_name}`}</div>
          <div style={{ marginLeft: 30 }}>{`清查期間：${checkIdDetail.start_date} - ${checkIdDetail.end_date}`}</div>
          <div style={{ flex: 1, display: 'flex', flexDirection: 'row-reverse' }}>
            <Button style={{ marginRight: 33, width: 97, height: 47, backgroundColor: '#66d4db', color: 'white', fontSize: 20, borderRadius: 5 }} onClick={() => this.setState({ dialog_Export: true })}>
              <svg style={{ marginRight: 7 }} width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.001 3.80938C12.001 3.6125 11.9229 3.42188 11.7823 3.28125L8.72263 0.21875C8.582 0.078125 8.39135 0 8.19134 0H8.00069V4H12.001V3.80938ZM17.8453 9.625L14.8544 6.6125C14.5388 6.29688 13.9981 6.51875 13.9981 6.96562V9H11.9979V11H13.9981V13.0375C13.9981 13.4844 14.5388 13.7063 14.8544 13.3906L17.8453 10.375C18.0516 10.1687 18.0516 9.83125 17.8453 9.625ZM6.00052 10.5V9.5C6.00052 9.225 6.22554 9 6.50056 9H12.001V5H7.75067C7.33814 5 7.00061 4.6625 7.00061 4.25V0H0.750065C0.334404 0 0 0.334375 0 0.75V15.25C0 15.6656 0.334404 16 0.750065 16H11.251C11.6666 16 12.001 15.6656 12.001 15.25V11H6.50056C6.22554 11 6.00052 10.775 6.00052 10.5Z" fill="white" />
              </svg>
              匯出
            </Button>
          </div>
        </div>
        {this.renderTable()}
        {haveData && this.renderTableBar()}
        {!haveData && <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: 30 }}>尚無資料</div>}
        <div style={{ marginTop: 20, width: '100%', display: 'flex', justifyContent: 'center' }}>
          <EAA_Btn text='返回' backgroundColor={leftColor} onClick={_onClose} />
        </div>
        {dialog_Export && <CheckExport num={total} isCsv={false} onExport={() => exportCheckIdExcel(id, checkIdDetail.user_check_name)} onClose={() => { this.setState({ dialog_Export: false }); }} />}
      </div>
    );
  }
}
const mapStateToProps = state => ({
  checkIdDetail: state.data.CheckIdDetail,
  checkIdPageList: state.data.CheckIdPageList,
});
const mapDispatchToProps = dispatch => ({
  setPageText: text => Actions.setPageText(dispatch, { text }),
  getCheckIdDetail: id => Actions.getCheckIdDetail(dispatch, { id }),
  getCheckIdPageList: body => Actions.getCheckIdPageList(dispatch, body),
  exportCheckIdExcel: (id, name) => Actions.exportCheckIdExcel(dispatch, { id, name }),
  clearKey: key => Actions.clearKey(dispatch, { key }),
});

export default connect(mapStateToProps, mapDispatchToProps)(RecordView);
